module.exports = __webpack_public_path__ + "img/support_e8.97ebdda6.png";